// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2m3Vr","upload":"Small_upload__3FoyB","imageWrap":"Small_imageWrap__1PwcJ","removeBtn":"Small_removeBtn__3uNhJ"};